import SoftBadge from 'components/common/SoftBadge';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const StatusBadge = ({ status }) => (
  <SoftBadge
    className="fs--3"
    bg={classNames({
      success: status === 'Activa',
      warning: status === 'Pausada',
      primary: status === 'Finalizada',
      secondary: status === 'Pendiente',
      danger: status === 'Eliminada'
    })}
  >
    <strong>{status}</strong>
  </SoftBadge>
);

StatusBadge.propTypes = {
  status: PropTypes.string
};

export const projectColumns = [
  {
    accessor: 'address',
    Header: 'Dirección',
    headerProps: { title: 'Ordenar por dirección' },
    canSort: true
  },
  {
    accessor: 'price',
    Header: 'Precio',
    headerProps: { title: 'Ordenar por precio' },
    canSort: true
  },
  {
    accessor: 'updated_at',
    Header: 'Última modificación',
    headerProps: { title: 'Ordenar por fecha de modificación' },
    canSort: true
  },
  {
    accessor: 'type',
    Header: 'Inmueble',
    headerProps: { title: 'Ordenar por tipo de inmueble' },
    canSort: true
  },
  {
    accessor: 'status',
    Header: 'Estado',
    headerProps: { title: 'Ordenar por estado' },
    canSort: true,
    Cell: StatusBadge
  },
  {
    accessor: 'builder.deadline',
    Header: 'Fecha de entrega',
    headerProps: { title: 'Ordenar por fecha de entrega' },
    canSort: true
  },
  {
    accessor: 'share',
    Header: 'Compartida',
    headerProps: { title: 'Ordenar por compartido' },
    Cell: ({ share }) =>
      share?.active && share?.percent ? `Si (${share.percent}%)` : 'No'
  },
  {
    accessor: 'actions',
    Header: 'Acciones',
    headerProps: { style: { cursor: 'default' }, title: null },
    canSort: false
  }
];
